import {
  Directive,
  HostListener,
  HostBinding,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';

@Directive({
  selector: '[fileDrop]',
  standalone: true,
})
export class FileDropDirective {
  @Input() allowedExtensions: Array<string> = [
    'application/pdf',
    'text/plain',
    'text/csv',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
  ];
  @Input() allowMultipleFiles: boolean = false;
  @Input() maxFileSize: number = 10485760;
  @Output() private filesChangeEmitter: EventEmitter<File[]> =
    new EventEmitter();
  @Output() private invalidFileEmitter: EventEmitter<File> = new EventEmitter();
  @HostBinding('style.background') private background = 'white';
  @HostBinding('style.border') private borderStyle = '2px dashed';
  @HostBinding('style.border-color') private borderColor = 'rgba(151,153,155,0.65)';
  @HostBinding('style.border-radius') private borderRadius = '4px';

  constructor() {}

  @HostListener('dragover', ['$event']) public onDragOver(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#ececec';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = 'white';
  }

  @HostListener('drop', ['$event']) public onDrop(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = 'white';
    let files: File[] = Object.values(evt.dataTransfer.files);
    let validFiles: Array<File> = files.filter(
      (file) =>
        this.allowedExtensions.includes(file.type) &&
        file.size <= this.maxFileSize,
    );
    let invalidFiles: Array<File> = files.filter(
      (file) =>
        !(
          this.allowedExtensions.includes(file.type) &&
          file.size <= this.maxFileSize
        ),
    );
    if (validFiles.length > 0) {
      if (!this.allowMultipleFiles)
        this.filesChangeEmitter.emit([validFiles[0]]);
      if (this.allowMultipleFiles) this.filesChangeEmitter.emit(validFiles);
    } else {
      for (let invalidfile of invalidFiles) {
        this.invalidFileEmitter.emit(invalidfile);
      }
    }
  }
}
